import { gql } from "@apollo/client";

export const GET_ALL_CLASIFICACIONES_IR = gql`
  query allClasificacionReclamo {
    allClasificacionReclamo {
        idClasificacionReclamo
        descripcion
    }
}`;

export const adaptClasificacionesReclamoArray = (clasificaciones) =>
structuredClone(clasificaciones?.allClasificacionReclamo)?.
map((clasificacion) => ({
  id: clasificacion?.idClasificacionReclamo,
  displayName: clasificacion?.descripcion
}));